import { Label } from '@talentmesh/ui/components/label';
import { Switch } from '@talentmesh/ui/components/switch';

export interface LabeledSwitchProps {
    label: string;
    checked?: boolean;
    disabled?: boolean;
    onCheckedChange?: (checked: boolean) => void;
    name?: string;
}

function LabeledSwitch({ label, checked, disabled, onCheckedChange, name }: LabeledSwitchProps) {
    return (
        <div className="flex items-center gap-4">
            <Switch id={name} checked={checked} disabled={disabled} onCheckedChange={onCheckedChange} />
            <Label htmlFor={name} className="cursor-pointer text-sm leading-none font-normal">
                {label}
            </Label>
        </div>
    );
}

export default LabeledSwitch;
